module.exports = __webpack_public_path__ + "static/jobPreview-66ed208d9d72652cb35854f5513154ff.jpg";